import React from 'react';
import ReportPage from '../ReportChart/ReportPage';
import { getDefectsByRiskRating } from "services/analytics";
import useChartColors from '../ReportChart/hooks/useChartColors';

const DefectsRiskRatingReport = () => {
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();

  const chartConfig = {
    id: 'defects-by-risk-rating',
    title: `${customCaptions?.defectPlural} by Risk Rating`,
    fetchData: async (params) => {
      return await getDefectsByRiskRating(params);
    },
    allowedChartTypes: ['tree-map', 'pie', 'vertical-bar'],
    defaultChartType: 'tree-map',
    axisConfig: {
      categoryAxis: { dataKey: 'label' },
      valueAxes: [{ 
        label: 'Count' 
      }]
    },
    series: [
      { 
        label: 'Count', 
        key: 'count', 
        showLegend: false,
        colors: getAllColors()
      }
    ],
    transformData: (response) => {
      return response?.data?.data?.map(item => ({
        ...item,
        defectRiskRatingId: item.id
      }));
    },
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
      },
      department: { multiSelect: true },
      model: true
    },
    viewData: '/app/defects', //This could be a function that returns the path based on the data
    itemNavigation: true,
    drilldown: {
      defaultChartType: 'tree-map',
      allowedChartTypes: ['tree-map', 'pie', 'vertical-bar'],
      axisConfig: {
        categoryAxis: { dataKey: 'label' },
        valueAxes: [{ 
          label: 'Count' 
        }]
      },
      series: [
        { 
          label: 'Count', 
          key: 'count', 
          showLegend: false,
          colors: getAllColors()
        }
      ],
      currentDrilldownLabel: `${customCaptions?.asset || 'Asset'}`,
      getParams: (dataPoint) => {
        return {
          defectRiskRatingId: dataPoint.defectRiskRatingId,
          // LEGACY HANDLING: Add the legacy riskRating structure for backward compatibility
          // This should be removed once we fully support URL param passing - EMI3FE-111
          riskRatings: {
            id: dataPoint.defectRiskRatingId,
            name: dataPoint.name || "Show All"
          }
        };
      }
    }
  };

  return (
    <ReportPage 
      title={`${customCaptions?.defectPlural} by ${customCaptions?.riskRating || 'Risk Rating'}`}
      chartConfig={chartConfig}
    />
  );
};

export default DefectsRiskRatingReport; 
